// Application constants
export const BRAND_NAME = 'Forteuno Web'
export const APP_NAME = BRAND_NAME
export const APP_DESCRIPTION = 'Custom AI automations for modern businesses'

export const WHATSAPP_NUMBER = '+212620819683'
export const WHATSAPP_URL =
  'https://wa.me/212620819683?text=Hello%2C%20I%20would%20like%20to%20learn%20more%20about%20Forteuno%20Web.'

// Navigation items
export const NAV_ITEMS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Contact', path: '/contact' },
] as const

